import React from 'react'
import { FLAGS } from '../../config'
import { useFlagsContext } from '../../providers'

export const ExperienceWrapper = ({ Registration, Countdown, Conference, AfterConference }) => {
  const { [FLAGS.SITE_EXPERIENCE]: siteExperienceFlag } = useFlagsContext()

  if (!Registration || !Countdown || !Conference || !AfterConference) {
    throw new Error('ExperienceWrapper: All experience components must be provided')
  }

  if (siteExperienceFlag?.treatment === 'registration') {
    return <Registration />
  }
  if (siteExperienceFlag?.treatment === 'countdown') {
    return <Countdown />
  }
  if (siteExperienceFlag?.treatment === 'conference') {
    return <Conference />
  }
  return <AfterConference />
}
